var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgNpr = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7338_15982)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 24.2673C18.6274 24.2673 24 18.8948 24 12.2673C24 5.63992 18.6274 0.267334 12 0.267334C5.37258 0.267334 0 5.63992 0 12.2673C0 18.8948 5.37258 24.2673 12 24.2673Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9292 13.5718C23.9292 13.5717 23.9293 13.5716 23.9293 13.5714L10.7693 0.329834C10.1757 0.39035 9.59475 0.494131 9.02986 0.63799C3.83897 1.95963 0 12.2674 0 12.2674C0 12.2674 16.7999 23.5097 18.7165 22.2126C19.1 21.9531 19.4677 21.672 19.8177 21.3711L12.0185 13.5718H23.9292Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8695 12.266L9.19899 0.595459C3.92288 1.85719 0 6.6031 0 12.266C0 18.8933 5.37263 24.266 12 24.266C14.5139 24.266 16.8467 23.4924 18.7748 22.1712L8.86955 12.266H20.8695Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4116 17.984L9.94606 17.2946L10.7265 15.8753L9.13508 16.1797L8.93342 14.572L7.82497 15.7544L6.71652 14.572L6.51481 16.1797L4.92345 15.8752L5.70387 17.2946L4.23828 17.984L5.70387 18.6733L4.92345 20.0926L6.51491 19.7882L6.71647 21.3958L7.82497 20.2134L8.93342 21.3958L9.13508 19.7882L10.7264 20.0927L9.94602 18.6734L11.4116 17.984Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4342 6.92077L9.36828 6.41944L9.93589 5.38711L8.77841 5.60855L8.63174 4.43921L7.82553 5.29922L7.01933 4.43921L6.87261 5.60855L5.71512 5.38711L6.28278 6.41944L5.2168 6.92077L7.82553 7.44258L10.4342 6.92077Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9562 6.91968C10.9562 8.64857 9.55466 10.0501 7.82576 10.0501C6.09687 10.0501 4.69531 8.64857 4.69531 6.91968",
    fill: "#F0F0F0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7338_15982"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.267334)"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgNpr);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/NPR.53c329b6678b92aff4393617ad193054.svg";